import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { RolesList, RolesDisableList } from 'src/components/M_Components/M_Utils/roleConfigList'
import { M_InputTextField, M_Button, LoadingContext, M_StateActions, M_CheckBox, M_Header, BufferService } from 'src/components/M_Components'
import { useDispatch, useSelector } from 'react-redux'
import './pages.css'

export const RoleConfigCrud = ({ handleTabClose }) => {
    const dispatch = useDispatch()
    const M_State = useSelector(state => state.StateKeyValue)
    const passOperation = M_State.filter(obj => obj.key === 'operation')[0]?.value !== null ? M_State.filter(obj => obj.key === 'operation')[0]?.value : 'Error'
    const sessionLine = M_State.filter(obj => obj.key === 'rolesLine')[0]?.value !== null && M_State.filter(obj => obj.key === 'rolesLine')[0]?.value !== undefined ? M_State.filter(obj => obj.key === 'rolesLine')[0]?.value : 'Error'
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [roleName, setRoleName] = useState('')
    const [permissions, setPermissions] = useState([])
    const [operation, setOperation] = useState(passOperation)
    const [passLine, setPassLine] = useState('')
    const [isFirst, setIsFirst] = useState(true)
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    const bufferRoles = new BufferService('viewroledetails')
    const columns = ["List", "Create", "Edit", "Delete", "SelectAll"]
    const sessionKeys = ['operation', 'roleName', 'permissions', 'passLine', 'isFirst']

    useEffect(() => {
        if (isFirst) {
            dispatch(M_StateActions.removeM_State({ key: 'rolesLine' }))
            dispatch(M_StateActions.removeM_State({ key: 'operation' }))
            setPassLine(sessionLine)
            setIsFirst(false)
        }
        getSessionStorageData(id)
        // eslint-disable-next-line
    }, [])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempO = M_StateData.filter(obj => obj?.key === `operation`)[0]?.value
            const tempRN = M_StateData.filter(obj => obj?.key === `roleName`)[0]?.value
            const tempP = M_StateData.filter(obj => obj?.key === `permissions`)[0]?.value
            const tempL = M_StateData.filter(obj => obj?.key === `passLine`)[0]?.value
            const tempIF = M_StateData.filter(obj => obj?.key === `isFirst`)[0]?.value
            if (tempO || tempRN || tempP || tempL || tempIF) {
                setOperation(tempO)
                setRoleName(tempRN)
                setPermissions(tempP)
                setPassLine(tempL)
                setIsFirst(tempIF)
                ctx.setIsLoad(false)
                return
            }
        }
        getRefresh(sessionLine)
    }

    // eslint-disable-next-line
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, operation, roleName, permissions, passLine])

    const getRefresh = (line) => {
        const lineRole = line ? line : passLine
        let tempArray = JSON.parse(RolesList)
        if (operation === 'Create') {
            setPermissions(tempArray)
            ctx.setIsLoad(false)
        } else {
            if (lineRole === 'Error') {
                handleTabClose(id)
                ctx.toastMessages('error', '', t("SelectedLine"))
                return
            }
            setRoleName(lineRole.Name)
            bufferRoles.getId(lineRole.Name).then((response) => {
                response.forEach(perm => {
                    columns.forEach(col => {
                        if (perm.match(col)) {
                            tempArray = tempArray.map(obj => {
                                if (obj.Value == perm.split(col)[0]) {
                                    obj[col] = true
                                    return obj
                                } else return obj
                            })
                        }
                    })
                })
                setPermissions(tempArray)
                ctx.setIsLoad(false)
                ctx.toastMessages('success', '', t("LabelRoleSucc"))
            }).catch((error) => {
                ctx.toastMessages('error', '', error.message)
                handleTabClose(id)
                setPermissions(tempArray)
            })
        }
    }

    const checkboxBody = (e, items) => {
        if (items === 'SelectAll') {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '20px' }}>
                    <M_CheckBox
                        disableRipple={true}
                        checked={e[items] || false}
                        disabled={operation === 'View'}
                        onChange={(elem) => selectAll(e.Name, elem.target.checked)}
                    />
                </div>
            )
        }
        if (RolesDisableList.includes(`${e.Value}${items}`) || operation === 'View') {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '20px' }}>
                    <M_CheckBox
                        disabled={true}
                        checked={e[items] || false}
                        onChange={(elem) => changeTable(e.Name, items, elem.target.checked)}
                    />
                </div>
            )
        } else {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '20px' }}>
                    <M_CheckBox
                        checked={e[items] || false}
                        onChange={(elem) => changeTable(e.Name, items, elem.target.checked)}
                    />
                </div>
            )
        }
    }

    const selectAll = (data, value) => {
        const tempArray = permissions.map(obj => {
            if (obj.Name === data) {
                const tempObj = { ...obj }
                columns.forEach(element => {
                    if (RolesDisableList.includes(obj.Value + element)) {
                        return
                    }
                    tempObj[element] = value
                });
                return tempObj
            }
            return obj
        })
        setPermissions(tempArray)
    }

    const changeTable = (name, field, value) => {
        setPermissions(permissions.map(obj => {
            if (obj.Name == name) {
                return {
                    ...obj,
                    [field]: value
                }
            } else return obj
        }))
    }

    const onSave = () => {
        ctx.setIsLoad(true)
        const permissionsArray = []
        permissions.forEach(obj => {
            Object.entries(obj).forEach(keyValue => {
                if (keyValue[0] !== 'Name' && keyValue[0] !== 'Value' && keyValue[1]) {
                    permissionsArray.push({
                        "Key": "PERMISSION",
                        "Value": `${obj.Value}${keyValue[0]}`
                    })
                }
            })
        })
        if (operation === 'Create' || operation === 'Copy') {
            bufferRoles.postId(roleName, permissionsArray)
                .then((response) => {
                    ctx.setIsLoad(false)
                    ctx.toastMessages('success', '', t('Success'))
                    setTimeout(() => {
                        handleTabClose(id)
                    }, 1000)
                })
                .catch((error) => {
                    ctx.toastMessages('error', '', error.message)
                })
        } else {
            bufferRoles.putQuery(`/${roleName}?id=${passLine.Id}`, permissionsArray)
                .then((response) => {
                    ctx.setIsLoad(false)
                    ctx.toastMessages('success', '', t('Success'))
                    setTimeout(() => {
                        handleTabClose(id)
                    }, 1000)
                })
                .catch((error) => {
                    ctx.toastMessages('error', '', error.message)
                })
        }
    }

    return (
        <div className='firstDivContainer'>
            <M_Header
                element={<>
                    <M_Button
                        tooltip={t("RefreshTable")}
                        icon={<i className="pi pi-refresh headerIcon"></i>}
                        label={<b>{t("RefreshTable")}</b>}
                        onClick={() => getRefresh()}
                    />
                    <M_Button
                        tooltip={t("Save")}
                        icon={<i className="pi pi-save headerIcon"></i>}
                        label={<b>{t("Save")}</b>}
                        onClick={() => onSave()}
                    />
                </>}
            />
            <div className='tableDiv'>
                <div style={{ width: '250px' }}>
                    <M_InputTextField disabled={operation === 'View' ? true : false} label={t("LabelRoleName")} value={roleName} onChange={(e) => setRoleName(e.target.value)} />
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                <DataTable className={'datatable'} value={permissions} size='small' paginator rows={15} tableStyle={{ maxWidth: '80%' }}>
                    <Column field='Name' header='' style={{ minWidth: '250px', width: '250px', maxWidth: '250px', fontWeight: 'bold' }} body={(e) => t(e.Name)} filterMatchMode="contains" />
                    {columns.map((items, index) => (
                        <Column key={index} field={items} header={t(items)} body={(e) => checkboxBody(e, items)}>items</Column>
                    ))}
                </DataTable>
            </div>
        </div >
    )
}
